import { Controller } from "@hotwired/stimulus"

// Closes the "edit display name" modal after a successful Turbo save.
//
// The rename form posts via Turbo and the controller responds with a
// turbo_stream that swaps the editor heading in place — so on a 2xx we just hide
// the Bootstrap modal. On a 4xx (validation error) the stream re-renders the
// form with the message instead, and we leave the modal open so the admin sees it.
export default class extends Controller {
  onSubmitEnd(event) {
    if (!event.detail.success) return

    const modal = this.element.closest(".modal")
    if (modal && window.bootstrap) {
      window.bootstrap.Modal.getOrCreateInstance(modal).hide()
    }
  }
}
